import { ShiftPostPage } from '@features/shift-post-v2/pages'
import { IRoster } from '@src/models/Roster'
import { FormikProps } from 'formik'

export interface IAcceptanceCriteriaStepProps {
  sourcePage: ShiftPostPage
  formik?: FormikProps<IAcceptanceCriteriaFormValues>
}

export interface IAcceptanceCriteriaFormValues {
  auto_accept: boolean
  auto_accept_by_rosters: boolean
  auto_accept_certificate_ids: number[]
  auto_accept_roster_ids: number[]
  auto_accept_rosters: IRoster[]
  switch_to_auto_accept_after_invite_terminated: boolean
  auto_accept_by_onboarded: boolean
  roster_ids: number[]
}

export enum ACCEPTANCE_CRITERIA_OPTION {
  VERIFIED = 1,
  VERIFIED_FROM_ROSTERS = 2,
  PERSONALLY_APPROVED = 3,
}
